import React, { useState } from "react";
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { Button, ButtonIcon, FormHeader, InputBox } from "../../../components";
import { CheckValidity, login } from "../../../utils";
import { notification } from "antd";
import {
  closeEmailChangeModal,
  setAdsUserDetails,
} from "../../AdsPlatform/redux/actions";
import {
  getExistingByUserName,
  updateCompanyUserName,
} from "../../AdsSignIn/service/auth.service";

const Index = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: {
      key: "email",
      label: "Working email address",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "Enter you working email address",
      },
      validation: {
        required: true,
        email: true,
      },
      touched: false,
      isValid: false,
      isLoading: false,
      invalidReason: "",
      value: "",
      isRequired: false,
    },
  });

  const { isOpenEmailChangeModal, signupUser } = useSelector(
    ({ adsUserReducer }) => adsUserReducer
  );

  const dispatch = useDispatch();

  const handleChange = async (event, inputIdentity) => {
    const updateContactForm = {
      ...formData,
    };

    updateContactForm[inputIdentity].value = event;

    let validityRes = await CheckValidity(
      inputIdentity,
      updateContactForm[inputIdentity].value,
      updateContactForm[inputIdentity].validation
    );

    if (validityRes) {
      updateContactForm[inputIdentity].isValid = validityRes.isValid;
      updateContactForm[inputIdentity].invalidReason = validityRes.reason;
      updateContactForm[inputIdentity].touched = true;

      let formIsValid = false;
      for (let inputIdentifier in updateContactForm) {
        formIsValid = updateContactForm[inputIdentifier].valid && formIsValid;
      }

      setFormData(updateContactForm);
    }
  };

  const onClickUpdateUserName = async () => {
    const updateForm = { ...formData };
    setIsLoading(true);
    try {
      if (updateForm.email.value) {
        let isExisting = await getExistingByUserName({
          email: updateForm.email.value,
        });
        console.log("isExisting", isExisting);
        if (!isExisting?.data?.status) {
          let resVerify = await updateCompanyUserName(
            {
              email: updateForm.email.value,
            },
            signupUser?.company_id
          );
          console.log("resVerify", resVerify);
          if (resVerify.data.status) {
            setIsLoading(false);
            login(resVerify.data?.token);
            dispatch(setAdsUserDetails(resVerify.data.data));
            dispatch(closeEmailChangeModal());
          } else {
            notification.error({
              message: "Error",
              description: resVerify.data.message,
            });
            setIsLoading(false);
          }
        } else {
          notification.error({
            message: "Error",
            description: isExisting.data.message,
          });
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error updating user name:", error);
      setIsLoading(false);
      notification.error({
        message: "Error",
        description: "Failed to update email. Please try again.",
      });
    }
  };

  const updateContactForm = { ...formData };

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenEmailChangeModal ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-wrapper modal-container d-flex flex-column  animate__animated  ${
          isOpenEmailChangeModal ? "open_me animate__bounceIn" : "close__me"
        }`}
      >
        {/* <BgEffect /> */}
        <FormHeader
          data={{
            layerStyle: "mb-1",
            formHeader: "Change Email",
            lan: "en",
            size: "lg",
          }}
        />
        <div className="common-modal-close">
          <ButtonIcon
            data={{ iconName: "cross", size: "sm" }}
            onClick={() => dispatch(closeEmailChangeModal())}
          />
        </div>
        <div className="signup-form">
          <InputBox
            data={updateContactForm.email}
            onChange={async (e) => {
              await handleChange(e.target.value, updateContactForm.email.key);
            }}
          />
          <div className="d-flex mt-4">
            <Button
              data={{
                btnName: "Change Email",
                buttonType: "primary",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                await onClickUpdateUserName();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
